import { Post } from "services";
import { ApiPath } from "paths";

export const getCurrencies = async () => {
  const res = await Post(`${ApiPath.SEARCH_CURRENCY_LIST}`, {});
  return res.data;
};
